<template>
  <div class="modal" :id="id" tabindex="-1">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{ title }}</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Luk"></button>
        </div>
        <div class="modal-body">
          <slot />
        </div>
        <div class="modal-footer">
          <button class="btn btn-primary w-100" type="button" data-bs-dismiss="modal" aria-label="Luk">{{ $t('modal_accept_button_text') }}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import {defineComponent} from 'vue';

export default defineComponent({
  name: 'Modal',
  props: [
      'id',
      'title'
  ],
});
</script>

<style lang="scss">
</style>
